import React, {useEffect, useRef} from 'react';
import {Popup} from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import DataGrid, {Column, Editing, Scrolling, Selection} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label, FormRef} from "devextreme-react/form";
import IReservationDetailOccupant from "../../models/IReservationDetailOccupant";
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import {} from 'devextreme-react';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";

export default function GestionListeOccupants() {
    const reservationFormDataSource = useCustomDataSource<IReservationDetailOccupant, IReservationDetailOccupant>({path: "reservationDetailOccupant", primaryKey: "idReservationDetailOccupant"});
    const {selectedDataRow: selectedReservation, mode, setMode, isFieldModifier, setIsFieldModifier, setMainForm, onFieldDataChanged} = reservationFormDataSource;
    const formRef = useRef<FormRef>(null);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    return (
        <Popup
            visible={true}
            // visible={this.state.popupVisible}
            // onHiding={this.hideInfo}
            dragEnabled={true}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={true}
            title="Liste des occupants"
            container=".dx-viewport"
            width={750}
            height={550}
        >
            <ScrollView width='100%' height='100%'>
                <FormListBase key={"frm-liste-occupants"}
                              data={reservationFormDataSource}>
                    <FormListBaseGrid
                        dataSource={reservationFormDataSource.dataSource}
                        onFocusedRowChanged={() => {
                            if (mode === Mode.Modifier) {
                                setMode(Mode.Lecture);
                            }
                        }}>
                        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false}/>
                        <Column key={"grid-col-prenom"} dataField={"prenom"} caption="Prénom" allowHiding={false}/>
                    </FormListBaseGrid>
                    <FormListBaseToolbar headerText={`${selectedReservation?.nom || ''} `} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{disabled: !isFieldModifier}}/>
                    <FormListBaseTab>
                        <TabItem title="">
                            <Form ref={formRef} readOnly={mode !== Mode.Lecture} formData={selectedReservation || {} as IReservationDetailOccupant} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                                <GroupItem>
                                    <DataGrid
                                        // dataSource={reservationFormDataSource.dataSource}
                                        focusedRowEnabled={true}
                                        defaultFocusedRowIndex={0}
                                        autoNavigateToFocusedRow={true}
                                        height={"100%"}
                                        noDataText={""}
                                    >
                                        <Editing allowAdding={mode !== Mode.Lecture} allowDeleting={mode !== Mode.Lecture} allowUpdating={mode !== Mode.Lecture} newRowPosition={"first"} mode={"cell"} startEditAction={"click"}/>
                                        <Selection mode={"single"}/>
                                        <Scrolling mode="virtual" showScrollbar="always"/>
                                        <Column caption={"Nom"} dataField={"nom"}>
                                        </Column>
                                        <Column caption={"Prénom"} dataField={"prenom"}>
                                        </Column>
                                        {/* <Column caption={"Note"} width={"50%"} dataType={"note"}>
                    </Column>
                    <Column caption={"Âge"} dataType={"age"}>
                    </Column>
                    <Column caption={"Cosignataire"} dataType={"cosignataire"}>
                    </Column> */}
                                    </DataGrid>
                                </GroupItem>
                            </Form>
                        </TabItem>
                    </FormListBaseTab>
                </FormListBase>
            </ScrollView>
        </Popup>
    );
}